var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":_vm.time_passed ? 'error': 'primary'},on:{"click":_vm.startStopTimer}},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"mx-1"},[_vm._v("mdi-timer")]),_vm._v(" "+_vm._s(_vm.formattedTime)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }